import * as Yup from 'yup';
import i18n from 'i18n';

const schema = Yup.object().shape({
  isTermsAccepted: Yup.bool()
    .required(() => i18n.t('auth:validation.termsRequired'))
    .oneOf([true], () => i18n.t('auth:validation.termsRequired')),
});

export default schema;
